import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { Work as WorkIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import CustomInput from "../FormFields/CustomInput/CustomInput";
import {
  noticeRequiredOptions,
  workPermitOptions,
} from "./CandidateForm.Config";
import countryList from "../invoiceComponents/data/countryList";

const CandidateCurrentJobForm = ({ handleChange, formData }) => {
  const noticeOptions = noticeRequiredOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  const permitOptions = workPermitOptions.map((item) => ({
    value: item.value,
    label: item.name || String(item.value),
  }));

  const countryOptions = countryList.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeader
        sx={{
          bgcolor: '#f8fafc',
          borderBottom: '1px solid #e2e8f0',
          py: 1.5,
          px: 2.5,
        }}
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: '#0f172a',
              fontSize: '0.95rem',
              letterSpacing: '0.02em',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <WorkIcon color="primary" sx={{ fontSize: 20 }} />
            Current Job
          </Typography>
        }
      />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Position Held"
              name="position_held"
              value={formData?.position_held || ""}
              onChange={handleChange}
              fullWidth
              size="small"
              placeholder="Enter position held"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={countryOptions}
              label="Nationality"
              name="nationality"
              value={formData?.nationality || ""}
              onChange={handleChange}
              placeholder="Select Nationality"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Current Salary"
              type="number"
              name="current_salary"
              value={formData?.current_salary || ""}
              onChange={handleChange}
              fullWidth
              size="small"
              placeholder="Enter current salary"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={noticeOptions}
              label="Notice Required"
              name="notice_required"
              onChange={handleChange}
              value={formData?.notice_required || ""}
              placeholder="Select Notice Period"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={permitOptions}
              label="Work Permit"
              name="work_permit"
              onChange={handleChange}
              value={formData?.work_permit || ""}
              placeholder="Select Work Permit"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateCurrentJobForm;